import * as React from "react"
const LaserBlast = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 32 32"
    {...props}
  >
    <title>{"laser-blast"}</title>
    <path d="M30.886 30.947v-1.524L20.29 18.747c-.444-1.113-.594-2.03-.712-2.865a1.104 1.104 0 1 0-.356-1.89c-.241-.793-.67-1.593-1.572-2.521-.943-.97-2.353-1.265-3.71-.913l1.306-1.306-2.344-2.344 1.22-1.22-3.112-3.112-1.22 1.22L6.573.579H.633v6.304l3.035 3.035-1.192 1.192 3.112 3.112L6.78 13.03l2.344 2.344 4.815-4.815a3.943 3.943 0 1 1-.382 7.811 1.448 1.448 0 0 0-1.948-.949 3.928 3.928 0 0 1-1.305-3.02c-.25 1.225.01 2.47.809 3.359a1.45 1.45 0 1 0 2.369 1.603c1.523.514 3.015.204 5.192.969l1.431 1.441a1.104 1.104 0 0 0 1.554 1.565l7.553 7.61h1.674zm-17.292-9.773a.86.86 0 1 0 1.215 1.216.86.86 0 0 0-1.215-1.216zm8.228-9.082a1.554 1.554 0 0 0-2.195-2.196 1.554 1.554 0 0 0 2.195 2.196zm-.149 5.738a.86.86 0 1 0 1.216-1.215.86.86 0 0 0-1.216 1.215z" />
  </svg>
)
export default LaserBlast
